import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGraphUniqueBnDev } from "./uniqueBnDevAPI";
// import { readFromFBDB } from "../../../../services/fbdb.data";

const initialState = {
  status: "idle",
  error: null,
  data: {},
  uniqueBrowsers: [],
  uniqueEngaged: [],
  weeks: [],
};

export const graphUniqueBnDev = createAsyncThunk(
  "uniqueBnDev/visitors",
  async (user, { rejectWithValue }) => {
    try {
      const dbpath = `${user}/graph-uniqueBnDev`
      // const response = await readFromFBDB(dbpath);
      const response = await fetchGraphUniqueBnDev(dbpath, user, 'graph-uniqueBnDev');
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const uniqueBnDevSlice = createSlice({
  name: "uniqueBnDev",
  initialState,
  reducers: {
    resetUniqueBnDevData: (state, action) => {
      return { ...initialState };
    },
    setUniqueEngaged: (state, action) => {
      state.uniqueEngaged = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(graphUniqueBnDev.pending, (state) => {
        state.status = "loading";
      })
      .addCase(graphUniqueBnDev.fulfilled, (state, action) => {
        state.status = "idle";
        state.error = null;
        const result = action.payload;
        // console.log(result);
        try {
          state.uniqueBrowsers = result[0][0]["data"];
          state.weeks = result[1];
          state.data = result;
        } catch (error) {
          // console.warn("uniqueBrowsers data not found!", error)
        }

      })
      .addCase(graphUniqueBnDev.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload?.error;
      });
  },
});

export const { resetUniqueBnDevData, setUniqueEngaged } = uniqueBnDevSlice.actions;

export const SelectUniqueBrowsers = (state) => state.uniqueBnDev.uniqueBrowsers;
export const SelectUniqueEngaged = (state) => state.uniqueBnDev.uniqueEngaged;
export const SelectWeeks = (state) =>
  state.uniqueBnDev.weeks;
export const SelectgraphUniqueBnDevStatus = (state) => state.uniqueBnDev.status;

export default uniqueBnDevSlice.reducer;